import { Fragment, JSX, h } from "@stencil/core";
import { getVehiclePurchaseRoutingKey } from "@phn/entities/routing-key";
import { TLink } from "@phn/entities/content";
import { EventActions } from "@phn/utility/constants";
import MenuItemCountIndicator from "./menu-item-count-indicator";

export default function MenuItemLink({
  content,
  count,
  showSkeleton,
}: {
  content: TLink | null;
  count: number;
  showSkeleton: boolean;
}): JSX.Element | null {
  return content ? (
    <Fragment>
      <phn-nd-menu-item
        elementId={getVehiclePurchaseRoutingKey(content.id)}
        key={content.id}
        class={`${showSkeleton ? "skeleton" : "vehiclepurchase-link"}`}
        analyticsId={content.id}
        text={content.text}
        link={content.link}
        datalayerEventAction={EventActions.NAVIGATION_LINK_CLICK}
        role="listitem"
      >
        <MenuItemCountIndicator count={count} />
      </phn-nd-menu-item>
    </Fragment>
  ) : null;
}
